import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";

import useMeta from "../hooks/useMeta";

export default function Society() {
  useMeta("The Saviar Society | Membership",
    "A private membership and community for women devoted to soft discipline, refinement, and intentional living.");
  return (
    <div data-testid="society-page">
      <Nav />
      <div className="page-hero">
        <div className="page-hero-bg" style={{ backgroundImage: "url('/images/owner-dinner-gathering.jpg')" }} />
        <div className="page-hero-content">
          <p className="eyebrow eyebrow-light">The Saviar Society</p>
          <h1>A private standard<br/>for elevated women.</h1>
          <p>A commitment to softness, refinement, and the life you were meant to lead — for alumni and invited members.</p>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <div className="grid-2">
            <Reveal>
              <p className="eyebrow">The Membership Promise</p>
              <div className="divider" />
              <h2 className="display" style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)", color: "var(--charcoal)", marginBottom: 24 }}>Inside, you build a life worth sipping on.</h2>
              <p className="body-lg" style={{ marginBottom: 24 }}>The Saviar Society is a curated community and access platform built around one principle: that you deserve a life as refined, intentional, and beautiful as the woman you are becoming.</p>
              <Link to="/apply" className="btn btn-primary" data-testid="society-apply">Apply for Membership</Link>
            </Reveal>
            <Reveal delay={120}>
              <div className="feature-image-wrap">
                <img src="https://images.unsplash.com/photo-1529543544282-ea669407fca3?w=900&q=80" alt="Saviar Society" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="section dark-section">
        <div className="container-x">
          <div style={{ textAlign: "center", maxWidth: 720, margin: "0 auto 48px" }}>
            <p className="eyebrow" style={{ marginBottom: 16 }}>Membership Tiers</p>
            <h2 className="display" style={{ fontSize: "clamp(1.8rem, 3vw, 2.8rem)", color: "var(--ivory)" }}>Choose your level of access.</h2>
          </div>
          <div className="grid-3">
            {[
              { name: "The Circle", price: "$97", url: "https://buy.stripe.com/14AcN479igR71Jp8BXcfK00", perks: ["Community access", "Monthly masterclass", "Rewire book + guides", "Event early access"], featured: false },
              { name: "The Society", price: "$197", url: "https://buy.stripe.com/eVqfZg0KUdEV73J5pLcfK01", perks: ["Everything in The Circle", "Soft Life Reset full access", "Members-only events", "Monthly 1:1 check-in call", "Private channel access"], featured: true },
              { name: "The Reserve", price: "$497", url: "https://buy.stripe.com/dRmaEWgJSasJ2Nt4lHcfK02", perks: ["Everything in The Society", "VIP concierge event access", "Bi-weekly personal sessions", "Bespoke wellness design", "Annual retreat invitation"], featured: false },
            ].map((t, i) => (
              <Reveal key={t.name} delay={i * 120}>
                <div style={{ padding: 40, border: t.featured ? "1px solid var(--gold)" : "1px solid rgba(184,150,90,.15)", position: "relative", height: "100%", background: t.featured ? "rgba(184,150,90,.05)" : "transparent" }}>
                  {t.featured && <div style={{ position: "absolute", top: 0, right: 0, background: "var(--gold)", color: "var(--ivory)", padding: "6px 14px", fontSize: ".64rem", letterSpacing: ".2em", textTransform: "uppercase" }}>Most Selected</div>}
                  <h3 style={{ fontFamily: "var(--serif)", fontWeight: 300, fontSize: "1.6rem", color: "var(--ivory)", marginBottom: 16 }}>{t.name}</h3>
                  <div style={{ fontFamily: "var(--serif)", fontSize: "2.6rem", color: "var(--gold-light)" }}>{t.price}</div>
                  <div style={{ fontSize: ".72rem", letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(250,246,238,.4)", marginBottom: 28 }}>/ month</div>
                  <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 10, marginBottom: 28 }}>
                    {t.perks.map((p) => <li key={p} className="body-sm">— {p}</li>)}
                  </ul>
                  <a href={t.url} target="_blank" rel="noopener noreferrer" className={`btn ${t.featured ? "btn-primary" : "btn-outline"}`} style={{ width: "100%" }} data-testid={`tier-${t.name.toLowerCase().replace(/\s+/g, "-")}`}>Join</a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
